import * as yup from 'yup';

const purchaseOrderDetailsScheme = yup.object().shape({
  po_reference_number: yup.string().required('Reference Number is required'),
  document_date: yup.string().required('Date is required'),
  notify_party: yup.string().nullable()
});

export { purchaseOrderDetailsScheme };
